module.exports = __webpack_public_path__ + "Roboto-BlackItalic.woff2?f75569f8a5fab0893fa712d8c0d9c3fe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlackItalic/Roboto-BlackItalic.woff2?v=2.137
// module id = 671
// module chunks = 7